import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/context`;

export enum CONTEXT_TYPES {
  BOX = "BOX",
  LOCATION = "LOCATION",
}

export interface IContext {
  type: CONTEXT_TYPES;
  id: number;
  name: string;
  token: string;
  provider?: string|null;
}

const state: {
  context: IContext|null,
} = {
  context: null,
};

const getters = {};

const mutations = {
  mutateContext(state, context) {
    state.context = context;
  },
};

const actions = {
  getByToken({commit}, payload: {token: string}) {
    return axiosInstance.get(`${baseUrl}/${payload.token}`)
      .then((data) => data.data);
  },
  updateContext({ commit }, payload) {
    commit("mutateContext", payload);
  },
  clearContext({ commit }) {
    commit("mutateContext", null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
